import { LightModeSemanticColors } from '@enechain/ecloud-designsystem'
import { FaClockRotateLeftRegular } from '@enechain/ecloud-icons'

import { ButtonTooltip } from '~/components/common/ButtonTooltip'
import { iconSize } from '~/constants/iconSize'

type Props = {
  legId: string
  onRevertLegToAuto: (legId: string) => void
  title: string
}

/**
 * 列単位で自動計算値に戻すボタン。
 * 生 button を使用する理由: グリッドヘッダ内の極小インラインアクション。
 * ecloud ChakraIconButton は最小 size が sm (32px) で視覚的に過大。
 * アクセシビリティは aria-label + title で担保する。
 */
export const RevertButton = ({
  legId,
  onRevertLegToAuto,
  title,
}: Props): React.ReactElement => (
  <ButtonTooltip content={title}>
    <button
      aria-label={title}
      onClick={(e) => {
        e.stopPropagation()
        onRevertLegToAuto(legId)
      }}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '2px',
        display: 'flex',
        alignItems: 'center',
        // eclair: text-mid-emphasis
        color: LightModeSemanticColors.Text.midEmphasis.value,
        flexShrink: 0,
      }}
      title={title}
      type="button"
    >
      {/*
        [DS差異] undo (arrow-rotate-left) は DS に未収録。
        操作の意味「手入力を破棄して自動計算値へ復元」に最も近い
        FaClockRotateLeftRegular (反時計回り・復元) に寄せる。
        DS への追加要望: design/ui-feasibility/dictionary/ds-gap-defaults.md 参照。
      */}
      <FaClockRotateLeftRegular
        boxSize={iconSize.gridInline}
        aria-hidden="true"
      />
    </button>
  </ButtonTooltip>
)
